import React from "react";
import { Provider } from "react-redux";
import { Router, Route, Switch } from "react-router-dom";
import styled from "styled-components";
import store from "./store";
import CompanyList from "./components/pages/CompanyList";
import LoginForm from "./components/pages/LoginForm";
import ForgotPasswordForm from "./components/pages/ForgotPassword";
import ResetPasswordForm from "./components/pages/ResetPassword";
import Terms from "./components/pages/Legal/Terms";
import Privacy from "./components/pages/Legal/Privacy";
import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import ModalServer from "./components/Modals/ModalServer";
import createHistory from "history/createBrowserHistory";
import ReactGA from "react-ga";
import "./styles/index.css"; //Global styles

const Page = styled.div`
  margin-top: 125px;
  @media screen and (max-width: 600px) {
    margin-top: 80px;
  }
`;

const history = createHistory();
const gaTrackingId = process.env.REACT_APP_GA_TRACKING_ID;
if (gaTrackingId) {
  ReactGA.initialize(gaTrackingId);
  history.listen((location) => {
    ReactGA.set({ page: location.pathname });
    ReactGA.pageview(location.pathname);
  });
}

export default class App extends React.Component {
  componentDidMount() {
    ReactGA.pageview(window.location.pathname);
  }

  render() {
    return (
      <Provider store={store}>
        <Router history={history}>
          <div className="flex-col page-container">
            <Header />
            <div className="page-layout">
              <Page className="container page-content">
                <Switch>
                  <Route path="/companies" component={CompanyList} />
                  <Route exact path="/terms" component={Terms} />
                  <Route exact path="/privacy" component={Privacy} />
                  <Route
                    exact
                    path="/forgot-password"
                    component={ForgotPasswordForm}
                  />
                  <Route
                    exact
                    path="/reset-password/:token?"
                    component={ResetPasswordForm}
                  />
                  <Route exact path="/" component={LoginForm} />
                </Switch>
              </Page>
              <ModalServer />
            </div>
            <Footer />
          </div>
        </Router>
      </Provider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app.js